const emmaforms = document.querySelectorAll<HTMLElement>(`.emma-form`);
const emmaFormRows = document.querySelectorAll<HTMLElement>(`.emma-form .e2ma_signup_form .e2ma_signup_form_row`);
var patchEmmaTimeout;

function patchEmmaLabels(): void {

  if (emmaforms && emmaFormRows) {
    emmaFormRows.forEach(emmaFormRow => {
      var input = emmaFormRow.querySelector<HTMLElement>('input');
      var label = emmaFormRow.querySelector<HTMLElement>('.e2ma_signup_form_label');
      if (input && label) {
        var labelText = label.innerText.replace(/\s\s+/g, ' ').trim();
        input.setAttribute('placeholder', labelText);
        label.style.display = 'none';
      };
    });
    
  }
}


function delayPatchEmmaLabels(): void {
  clearTimeout(patchEmmaTimeout);
  patchEmmaTimeout = setTimeout(function() {
    patchEmmaLabels();
    }, 500);
}


// Run on page load
document.addEventListener('DOMContentLoaded', () => {
  patchEmmaLabels();
});

// Delayed run on resize
window.addEventListener('resize', () => {
  delayPatchEmmaLabels();
});

// Delayed run on header & footer alerts DOM changes
let emmaObserver = new MutationObserver(() => {
  delayPatchEmmaLabels();
});
if (emmaforms) {
  emmaforms.forEach(emmaform => {
    emmaObserver.observe(emmaform, {
      characterDataOldValue: true,
      subtree: true,
      childList: true,
      characterData: true
    });
  });
}
